<template>
	<div class="inputContentBox">
		<yd-cell-group>
			<span class="title">{{title}}</span>
			<yd-cell-item arrow>
				<input
					slot="right"
					type="text"
					@click.stop="changeShow"
					v-model="inputStr"
					readonly
				>
			</yd-cell-item>
		</yd-cell-group>
		<yd-cityselect v-model="show1" ref="cityselectDemo" :callback="result1" :items="district" :columns="columns"></yd-cityselect>
		<div class="tip" v-if="!inputStr" @click="changeShow()">{{text}}</div>
	</div>
</template>

<script>
	import District from "ydui-district/dist/gov_province_city_area_id";
	
	export default {
		name: "inputComponent",
		props: ["title", "text", "value","changeAble","columns"],
		data() {
			return {
				show1: false,
				district: District
			};
		},
		computed: {
			inputStr: {
				get: function () {
					return this.value;
				},
				set: function (val) {
					this.$emit("input", val);
				}
			}
		},
		methods: {
			changeShow: function () {
				if (!this.changeAble) {
					this.show1 = true;
				}
			},
			result1(ret) {
				if(this.columns == 2){
					this.$emit("addressCode", ret.itemValue1 + "," + ret.itemValue2);
					this.inputStr = ret.itemName1 + " " + ret.itemName2;
				}else{
					this.$emit("addressCode", ret.itemValue1 + "," + ret.itemValue2 + "," + ret.itemValue3);
					this.inputStr = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
				}
				
			},
			checkSubmit: function () {
				if (!this.inputStr) {
					this.changeShow();
					this.$common.errTip(this.title + "不能为空！");
					return false;
				}
				return this.inputStr;
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
.inputContentBox {
	.address {
		width: 100%;
		text-align: left;
		text-indent: 0.1rem;
	}
	
	.yd-cell-arrow:after {
		content: '' !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/inputComponent/addressComponent.vue